import { angleFromCoordinates, isLocationsEqual, getAngleFromCoordinatesHistoryFunction, calcDistance } from '@jumbo/utils/locationHelper';
import {
  GET_ALL_JOURNEYS_SUCCESSFUL,
  GET_DISPATCHES_SUCCESS,
  GET_JOURNEY_SUCCESSFUL,
  GET_LOCATIONS_SUCCESSFUL,
  SET_SELECTED_DISPATCH_SUCCESS,
  GET_SELECTED_DISPATCH_SUCCESS,
  GET_LATEST_LOCATION_FOR_LOAD_SUCCESS,
  GET_LATEST_LOCATION_FOR_LOAD_FAILED,
  GET_LATEST_LOCATION_FOR_MULTIPLE_LOADS_SUCCESS,
  GET_SELECTED_DISPATCH_WITH_PUBLIC_ID_SUCCESS,
  GET_DISPATCHES_NEXT_PAGE_SUCCESS,
  SEARCH_DISPATCHES_SUCCESS,
  GET_DISPATCHES_COUNT,
  GET_DISPATCHES_REQUEST,
  RE_RENDER_MAP,
  ADD_CALL_LOG_FOR_DISPATCH,
  GET_TRACKING_LOADS,
  GET_CARRIER_REP_LIST,
  REDRAW_ROUTE_ON_MAP,
  ADD_LOCATION_HISTORY_FOR_LOAD,
  CLEAN_UP_SELECTED_LOAD_AND_LOCATION
} from 'redux/actions/tracking';

const getAngleFromCoordinatesHistory = getAngleFromCoordinatesHistoryFunction()

const INIT_STATE = {
  journeys: [],
  currentJourney: {},
  locations: [],
  lastEvaluatedKey: 0,
  totalLoads: 0,
  loads: [],
  isLoading: false,
  selectedLoad: {},
  selectedLoadLocation: {},
  loadsWithLocation: [],
  locationOfLoads: {},
  loadsCount: {},
  reRender: false,
  carrierRepList: [],
  redrawTruckRoute: {},
  truckLocationHistories:{},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALL_JOURNEYS_SUCCESSFUL: {
      // let updateJourneys = [ ...state.journeys, ...action.payload]
      return {
        ...state,
        journeys: [...state.journeys, ...action.payload],
        lastEvaluatedKey: action.lastEvaluatedKey,
      };
    }
    case GET_JOURNEY_SUCCESSFUL: {
      return {
        ...state,
        currentJourney: action.payload,
      };
    }
    case GET_LOCATIONS_SUCCESSFUL: {
      return {
        ...state,
        locations: action.payload,
      };
    }
    case GET_DISPATCHES_REQUEST: {
      return {
        ...state,
        isLoading: true,
        loads: action.reset ? [] : [...state.loads],
        totalLoads: action.reset ? 0 : state.totalLoads
      }
    }
    case GET_DISPATCHES_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loads: action.payload.dispatches,
        totalLoads: action.payload.total_count || 0,
      };
    }
    case GET_DISPATCHES_NEXT_PAGE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        loads: [...state.loads, ...action.payload.dispatches],
        totalLoads: action.payload.total_count || 0,
      };
    }
    case SEARCH_DISPATCHES_SUCCESS: {
      return {
        ...state,
        selectedLoad: (!!action.payload.dispatches.length && action.payload.dispatches[0]) || {},
        selectedLoadLocation: {},
      };
    }
    case SET_SELECTED_DISPATCH_SUCCESS: {
      return {
        ...state,
        selectedLoad: action.payload,
        selectedLoadLocation: {},
      };
    }
    case GET_SELECTED_DISPATCH_SUCCESS: {
      return {
        ...state,
        selectedLoad: action.payload,
      };
    }
    case GET_SELECTED_DISPATCH_WITH_PUBLIC_ID_SUCCESS: {
      return {
        ...state,
        selectedLoad: action.payload,
      };
    }
    case GET_LATEST_LOCATION_FOR_LOAD_SUCCESS: {
      const lastLocation =
        state?.selectedLoadLocation?.location?.geometry?.coordinates ? state.selectedLoadLocation.location.geometry.coordinates : [];
      const newLocation = action?.payload?.location?.geometry?.coordinates ? action.payload.location.geometry.coordinates : [];
      let loadIdentifier = action?.payload?.load_details?.stops[0]?.id ?? 0

      const rotation =
        lastLocation.length > 0 && newLocation.length > 0
          ? getAngleFromCoordinatesHistory(lastLocation[1], lastLocation[0], newLocation[1], newLocation[0], loadIdentifier)
          : 0;

      // console.log('LOCATION FETCHED Distance, rotation - ', 
      //   calcDistance(lastLocation[1], newLocation[1], lastLocation[0],  newLocation[0]),
      //   rotation
      // );

      return {
        ...state,
        selectedLoadLocation: { ...action.payload, rotation: rotation },
      };
    }
    case GET_LATEST_LOCATION_FOR_LOAD_FAILED: {
      return {
        ...state,
      };
    }
    case GET_LATEST_LOCATION_FOR_MULTIPLE_LOADS_SUCCESS: {
      const locationOfLoads = action.payload;
      const loadsWithLocation = state.loads.map(load => {
        if (locationOfLoads[load.id]) {
          return { ...load, ...locationOfLoads[load.id] };
        } else {
          return {...load};
        }
      });
      // const sortedLoads = loadsWithLocation.sort((load1, load2) => {
      //   return load1.updated_at > load2.updated_at ? -1 : load1.updated_at < load2.updated_at ? 1 : 0;
      // }); sorting is no longer required since the loads will be sorted in the backend based on updated at
      return {
        ...state,
        loads: loadsWithLocation,
      };
    }
    case GET_DISPATCHES_COUNT: {
      return {
        ...state,
        loadsCount: action.payload
      }
    }
    case RE_RENDER_MAP: {
      return {
        ...state,
        reRender: action.payload
      }
    }
    case ADD_CALL_LOG_FOR_DISPATCH: {
      return {
        ...state,
        selectedLoad: { ...state.selectedLoad, comments: [...state.selectedLoad.comments, action.payload] }
      }
    }
    case GET_TRACKING_LOADS: {
      const loads = action.isAppend ? [...state.loads, ...action.payload] : action.payload;
      return {
        ...state,
        loads:loads,
        lastEvaluatedKey: loads.length,
        totalLoads:action.totalLoads
      }
    }
    case GET_CARRIER_REP_LIST: {
      return {
        ...state,
        carrierRepList: action.payload
      }
    }
    case REDRAW_ROUTE_ON_MAP: {
      return {
        ...state,
        redrawTruckRoute: action.payload
      }
    }
    case ADD_LOCATION_HISTORY_FOR_LOAD: {
      return {
        ...state,
        truckLocationHistories:{ ...state.truckLocationHistories,
           [action.payload.loadId]: action.payload.locationsHistory
        }
      }
    }
    case CLEAN_UP_SELECTED_LOAD_AND_LOCATION: {
      return {
        ...state,
        selectedLoad: {},
        selectedLoadLocation: {}
      }
    }
    default:
      return state;
  }
};
